<template>
  <widget>
    <widget-header class="background-gradient-green-blue text-white tiny-forms">
      <i class="zmdi zmdi-file-plus pr-2"></i> New Payment info
      <h4 slot="right">
        <close-x @click="$emit('close')" class="text-white"></close-x>
      </h4>
    </widget-header>
    <widget-body>
      <div class="grid grid-cols-1 gap-y-2">
        <Superselect
          title="Select Payment Type"
          v-model="paymentType"
          :multiple="false"
          :required="true"
          :options="['Crypto Wallet (BTC)', 'Bank Transfer (via Wise)']"
        >
        </Superselect>

        <!--CRYPTO-->
        <div v-if="paymentType && paymentType == 'Crypto Wallet (BTC)'">
          <YInput
            v-model="walletId"
            label="Wallet Id"
            :required="paymentType == 'Crypto Wallet (BTC)' ? true : false"
            :error="validationErrorFields.includes('walletId')"
          ></YInput>
        </div>

        <!--WISE-->
        <div
          v-if="paymentType && paymentType == 'Bank Transfer (via Wise)'"
          class="grid grid-cols-1 gap-y-2"
        >
          <Superselect
            title="Select Currency"
            v-model="currency"
            track-by="code"
            label="code"
            :multiple="false"
            :options="wiseCurrencies || []"
            :loading="$apollo.queries.wiseCurrencies.loading"
            :required="paymentType != 'Crypto Wallet (BTC)' ? true : false"
            :error="validationErrorFields.includes('wiseCurrency')"
          >
          </Superselect>
          <Superselect
            v-if="currency"
            title="Payment Method"
            v-model="payOption"
            track-by="key"
            label="title"
            :multiple="false"
            :options="this.payOptions || []"
            :loading="$apollo.queries.wiseAccountDetails.loading"
            :required="paymentType != 'Crypto Wallet (BTC)' ? true : false"
            :error="validationErrorFields.includes('payOption')"
          >
          </Superselect>
          <div v-if="payOption" class="grid grid-cols-1 gap-y-2">
            <YInput
              v-model="filters.name.fullName"
              :error="validationErrorFields.includes('filters.name.fullName')"
              :required="paymentType != 'Crypto Wallet (BTC)' ? true : false"
              label="Account Holder"
            ></YInput>
            <YInput
              v-model="filters.aDetails['email']"
              label="Payment Notifications Email"
              :required="paymentType != 'Crypto Wallet (BTC)' ? true : false"
            ></YInput>
            <div
              v-for="(value, key) in getAccountRequirements"
              :key="key"
              class="grid grid-cols-1 gap-y-2"
            >
              <div
                v-if="value.fieldType == 'input' || value.fieldType == 'text'"
              >
                <YInput
                  v-model="filters.aDetails[value?.key]"
                  :label="value?.name"
                  :required="
                    paymentType != 'Crypto Wallet (BTC)' ? true : false
                  "
                  :error="validationErrorFields.includes(value?.name)"
                ></YInput>
              </div>
              <div v-if="value.fieldType == 'select'">
                <Superselect
                  :title="value?.name"
                  v-model="filters.aDetails[value?.key]"
                  track-by="name"
                  label="name"
                  :multiple="false"
                  :options="value?.valuesAllowed || []"
                  :loading="$apollo.queries.wiseCurrencies.loading"
                  :required="
                    paymentType != 'Crypto Wallet (BTC)' ? true : false
                  "
                  :error="validationErrorFields.includes('wiseCurrency')"
                >
                </Superselect>
              </div>
            </div>
          </div>
        </div>

        <YButton
          v-if="paymentType && paymentType == 'Crypto Wallet (BTC)'"
          color="blue"
          @click="saveBitcoinWallet()"
        >
          Create Bitcoin Pay Option
        </YButton>
        <YButton
          v-if="paymentType && paymentType == 'Bank Transfer (via Wise)'"
          color="blue"
          @click="saveWisePayment()"
        >
          Create Bank Transfer Pay Option
        </YButton>
      </div>
    </widget-body>
  </widget>
</template>
<script>
import WISE_GET_CURRENCIES from '@/graphql/PaymentOption/WiseGetCurrencies.gql'
import UPDATE_CREATE_WISE_ACCOUNT from '@/graphql/PaymentOption/WiseUpdateCreateAccount.gql'
import UPDATE_CREATE_USER_WALLET_DATA from '@/graphql/PaymentOption/UpdateCreateUserWalletData.gql'
import WISE_ACCOUNT_DETAILS from '@/graphql/PaymentOption/WiseGetAccountDetails.gql'
import wiseAllowedCountries from '@/assets/js/wiseAllowedCountries.js'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  apollo: {
    wiseCurrencies: {
      query: WISE_GET_CURRENCIES,
      update: data => data.wiseGetCurrencies,
      fetchPolicy: 'network-only',
      deep: true
    },
    wiseAccountDetails: {
      query: WISE_ACCOUNT_DETAILS,
      update: data => data.wiseGetAccountDetails,
      variables() {
        return {
          input: {
            //accountId: this.user.userDetails?.wiseAccountId ?? 838372526,
            // wiseAccountId: this.user.userDetails?.wiseAccountId ?? undefined,
            userId: this.user?.id ?? undefined,
            fullName: this.filters?.name?.fullName ?? undefined,
            paymentType: this.payOption?.key ?? undefined,
            details: this.filters?.aDetails ?? undefined,
            currencyCode: this.currency?.code,
            qouteId: this.quouteId ?? undefined
          }
        }
      },
      result(results) {
        if (this.optionChange == false) {
          this.createFilters(
            JSON.parse(JSON.stringify(results.data.wiseGetAccountDetails))
          )
        }
        this.payOptions = this.getPayOptions()
      },
      fetchPolicy: 'network-only',
      deep: true
    }
  },
  data() {
    return {
      wiseCountries: wiseAllowedCountries,
      validationErrorFields: [],
      walletId: null,
      paymentType: null,
      name: '',
      email: '',
      address: '',
      paymentBalance: '',
      nextPaymentDate: '',
      paymentMessage: '',
      balanceUploadDate: '',
      paymentMethod: '',
      threshold: '',
      payOption: null,
      filters: {
        name: {},
        aDetails: {}
      },
      computedAccountRequirements: null,
      payOptions: null,
      currentTitle: null,
      isVisible: true,
      isSubmitting: false,
      resetDetails: false,
      optionChange: false,
      currency: null,
      qouteId: null,
      queries: {
        WISE_ACCOUNT_DETAILS,
        WISE_GET_CURRENCIES
      }
    }
  },
  computed: {
    getAccountRequirements() {
      const data = this.wiseAccountDetails?.accountRequirementsData

      if (data) {
        const filtered = data.find(
          element => element.key === this.payOption.key
        )

        let requirements = filtered?.requirementsData ?? []

        const hasRecipientCountry = requirements.some(
          req => req.key === 'address.country'
        )

        if (!hasRecipientCountry) {
          requirements = [
            ...requirements,
            {
              __typename: 'AccountRequirementsData',
              type: 'aba',
              title: 'ACH',
              name: 'Recipient country',
              fieldType: 'select',
              minLength: null,
              maxLength: null,
              key: 'address.country',
              valuesAllowed: wiseAllowedCountries,
            },
          ]
        }

        return requirements
      }

      return []
    },
  },
  watch: {
    'currency.code'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.payOption = null
      }
    }
  },
  methods: {
    getPayOptions() {
      var types = []
      this.wiseAccountDetails?.accountRequirementsData.forEach(element => {
        types.push({
          title: element.title,
          key: element.key
        })
      })
      return types
    },
    saveWisePayment() {
      this.$apollo
        .mutate({
          // Query
          mutation: UPDATE_CREATE_WISE_ACCOUNT,
          // Parameters
          variables: {
            input: {
              wiseAccountId: this.user.userDetails?.wiseAccountId ?? undefined,
              userId: this.user.id,
              fullName: this.filters.name.fullName,
              paymentType: this.payOption.key,
              details: this.filters.aDetails,
              currencyCode: this.currency.code
            }
          }
        })
        .then(result => {
          var errors = result.data.wiseUpdateCreateRecipientAccount.errors
          if (errors !== null) {
            this.$toastr.e(errors)
          } else {
            this.$toastr.s('Success, Bitcoin payment option saved')
            this.$events.emit('refreshMeQuery', true)
          }
          this.isUpdating = false
          this.$store.dispatch('updateGlobalLoader', -1)
          this.$emit('close')
        })
        .catch(error => {
          // Error
          this.isUpdating = false
          this.$store.dispatch('updateGlobalLoader', -1)
          this.$toastr.e(error)
        })
    },
    saveBitcoinWallet() {
      this.$apollo
        .mutate({
          // Query
          mutation: UPDATE_CREATE_USER_WALLET_DATA,
          // Parameters
          variables: {
            input: {
              userId: this.user.id,
              walletId: this.walletId
            }
          }
        })
        .then(result => {
          var errors = result.data.updateCreateUserWalletData.errors
          if (errors !== null) {
            this.$toastr.e(errors)
          } else {
            this.$toastr.s('Success, Bitcoin payment option saved')
            this.$events.emit('refreshMeQuery', true)
          }
          this.isUpdating = false
          this.$store.dispatch('updateGlobalLoader', -1)
          this.$emit('close')
        })
        .catch(error => {
          // Error
          this.isUpdating = false
          this.$store.dispatch('updateGlobalLoader', -1)
          this.$toastr.e(error)
        })
    },
    createFilters(data) {
      for (const key in data.recipientAccount) {
        if (key === '__typename' || key === 'displayFields') continue
        const value = data.recipientAccount[key]

        if (key === 'type') {
          this.payOption = value
          continue
        }

        if (key === 'currency' && !this.resetDetails) {
          this.currency = value
          continue
        }
        if (typeof value === 'object' && value !== null) {
          const innerObject = {}
          for (const innerKey in value) {
            if (innerKey === '__typename') continue

            // Adjust address fields as per your requirement
            if (key === 'address') {
              innerObject[`address.${innerKey}`] = value[innerKey]
              if (innerKey === 'state' || innerKey === 'country') {
                innerObject[`address.${innerKey}`] = {
                  key: value[innerKey],
                  name: value[innerKey]
                }
              }
            } else {
              innerObject[innerKey] = value[innerKey]
            }
            // Assign the values to `filters` as required
            if (key === 'details') {
              this.filters.aDetails = innerObject
            } else {
              this.filters[key] = innerObject
            }
          }
        } else {
          this.filters[key] = value
        }
      }
      if (this.filters.address) {
        this.filters.aDetails = {
          ...this.filters.address,
          ...this.filters.aDetails
        }
      }

      if (this.resetDetails) {
        this.payOption = null
        this.filters.aDetails = {}
        this.resetDetails = false
      }
    }
  }
}
</script>
